<template>
<div>
Slot component 1
{{ at }}
</div>
</template>

<script>
export default {
  props: ["at"],
}
</script>
